var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45132 39.5487C4.32706 35.4244 2.00707 29.8326 2 24C2.00707 18.1674 4.32706 12.5756 8.45132 8.45132C12.5756 4.32706 18.1674 2.00707 24 2C29.8326 2.00707 35.4244 4.32706 39.5487 8.45132C43.6729 12.5756 45.9929 18.1674 46 24C45.9931 29.8326 43.673 35.4244 39.5487 39.5487C35.4244 43.673 29.8326 45.9931 24 46C18.1674 45.9929 12.5756 43.6729 8.45132 39.5487Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17C25.3807 17 26.5 15.8807 26.5 14.5C26.5 13.1193 25.3807 12 24 12C22.6193 12 21.5 13.1193 21.5 14.5C21.5 15.8807 22.6193 17 24 17Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 20,
    width: 5,
    height: 16,
    rx: 2.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoOutline);
export default __webpack_public_path__ + "static/media/icon-info-outline.03796444aba2a77a28ed993f2042137e.svg";
export { ForwardRef as ReactComponent };